import React from 'react';
import { createRoot } from 'react-dom/client';
import { Scheduler } from '../../../pages/scheduler';

const container = document.getElementById('scheduling-modal');
const root = createRoot(container!);

root.render(
  <>
    <Scheduler type="modal" />
  </>,
);
